import styles from "./SectionGroup.module.scss";

type SectionGroupProps = {
  children: React.ReactNode;
};

export const SectionGroup = ({ children }: SectionGroupProps) => {
  return <div className={styles["group"]}>{children}</div>;
};
